module.exports = __webpack_public_path__ + "static/media/w_premium_logo.8a394fae.png";